import { DEFAULT_CONFIG } from './config.js';
import { clamp } from './util.js';
/** Ports `betaSmoothedRate()`: Beta(2,2) prior avoids 0%/100% on tiny samples. */
export function betaSmoothedRate(xs) {
    const wins = xs.filter((x) => x.won).length;
    return (wins + 2) / (xs.length + 4);
}
/** Ports `recordStats()`. */
export function recordStats(predictions, n) {
    const xs = predictions.slice(-n);
    if (!xs.length)
        return { wins: 0, losses: 0, total: 0, rate: null };
    const wins = xs.filter((x) => x.won).length;
    return {
        wins,
        losses: xs.length - wins,
        total: xs.length,
        rate: wins / xs.length,
    };
}
/** Ports `findSimilar()`: strict match, relaxing progressively if the sample is too small. */
export function findSimilar(resolved, setup, config = DEFAULT_CONFIG) {
    let xs = resolved.filter((p) => p.action === setup.action &&
        p.regime === setup.regime &&
        p.trendKey === setup.trendKey &&
        p.distanceBucket === setup.distanceBucket &&
        Math.abs((p.scoreBucket || 0) - setup.scoreBucket) <= 10);
    if (xs.length < config.minimumSimilarSamples) {
        xs = resolved.filter((p) => p.action === setup.action &&
            p.regime === setup.regime &&
            p.trendKey === setup.trendKey &&
            Math.abs((p.scoreBucket || 0) - setup.scoreBucket) <= 20);
    }
    if (xs.length < config.minimumSimilarSamples) {
        xs = resolved.filter((p) => p.action === setup.action &&
            p.trendKey === setup.trendKey &&
            Math.abs((p.scoreBucket || 0) - setup.scoreBucket) <= 20);
    }
    return xs.slice(-200);
}
/**
 * Ports `calibrate()`. `resolved` must already be filtered to settled,
 * directional (UP/DOWN) predictions by the caller — this package does not
 * read history storage itself.
 */
export function calibrate(signal, resolved, config = DEFAULT_CONFIG) {
    const similar = findSimilar(resolved, {
        action: signal.action,
        regime: signal.regime,
        trendKey: signal.trendKey,
        distanceBucket: signal.distanceBucket,
        scoreBucket: signal.scoreBucket,
    }, config);
    const allDirectional = resolved.filter((p) => p.action === signal.action).slice(-300);
    let empirical = null;
    let empiricalN = 0;
    let source = 'MODEL';
    if (similar.length >= config.minimumSimilarSamples) {
        empirical = betaSmoothedRate(similar);
        empiricalN = similar.length;
        source = 'SIMILAR';
    }
    else if (allDirectional.length >= config.minimumCalibrationSamples) {
        const nearby = allDirectional.filter((p) => Math.abs((p.scoreBucket || 0) - signal.scoreBucket) <= 20);
        if (nearby.length >= config.minimumCalibrationSamples) {
            empirical = betaSmoothedRate(nearby);
            empiricalN = nearby.length;
            source = 'HISTORY';
        }
    }
    let probability = signal.baseProb;
    if (empirical != null) {
        const historyWeight = clamp(empiricalN / 50, 0.2, 0.75);
        probability = signal.baseProb * (1 - historyWeight) + empirical * historyWeight;
    }
    probability = clamp(probability, 0.5, 0.92);
    return {
        probability,
        empirical,
        empiricalN,
        source,
        similar,
    };
}
//# sourceMappingURL=calibration.js.map